module.exports = __webpack_public_path__ + "static/media/sitemap_v_3_french_v2.574aa46e.svg";